import { FC, useState } from 'react';
import styles from './NavItem.module.scss';
import { Link, useLocation } from 'react-router-dom';
import useYandexMetrica from 'hooks/useYandexMetrica';

// interface NavItem {}
interface NavListTypes {
  navItems?: any;
  unreadMessages?: number;
}

export const NavList: FC<NavListTypes> = ({ navItems, unreadMessages = 0 }) => {
  const [activeItem, setActiveItem] = useState<number>(0);
  const { pathname } = useLocation();
  const { sendGoal } = useYandexMetrica();

  const clickItem = (item: any, index: number) => {
    setActiveItem(index);

    if (item?.[2] === '/knowledge') {
      sendGoal('KnowledgePage');
    }

    if (item?.[2] === '/chat') {
      sendGoal('SupportPage');
    }
  };

  return (
    <nav className={styles.navWrapper}>
      <ul className={styles.list}>
        {navItems.map((item: any, i: number) => (
          <Link to={item[2]} key={i}>
            <li
              className={
                pathname.includes(item[2]) && item[2].length > 1
                  ? `${styles.active} ${styles.item}`
                  : styles.item
              }
              onClick={() => clickItem(item, i)}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <img className={styles.img} src={item[1]} alt={item[0]} />
                <p className={styles.title}>{item[0]}</p>
              </div>

              {item[0] === 'Поддержка' && unreadMessages > 0 && (
                <div className={styles.notificationBadge} />
              )}
            </li>
          </Link>
        ))}
      </ul>
    </nav>
  );
};
